import { render, staticRenderFns } from "./AnswerTypeLinearScale.vue?vue&type=template&id=0c9c2948"
import script from "./AnswerTypeLinearScale.vue?vue&type=script&lang=js"
export * from "./AnswerTypeLinearScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports